export default {
  layoutTitle: 'LaCEN - Score Biodiversité',
};
